$primary-green: #81ba43;

.banner {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	padding: 2rem 1.5rem;
	margin: 0.75rem;
	background: rgba($primary-green, 0.1);
	border: 1px solid rgba($primary-green, 0.3);
	border-radius: 10px;
	text-align: center;
}

.icon {
	color: $primary-green;
}

.title {
	font-weight: 700;
	font-size: 1rem;
	color: $primary-green;
	margin: 0;
}

.subtitle {
	font-size: 0.875rem;
	color: #6b7280;
	margin: 0;
}
